import React from 'react';
import { Award, Users, BookOpen } from 'lucide-react';
import useInView from '../hooks/useInView';
import './AboutSection.css';
import obImage from '../assets/OB-self.jpeg';
import masterImage from '../assets/ob-master.jpeg';

const AboutSection = () => {
  const { ref, isInView } = useInView();

  const values = [
    {
      icon: <Users size={24} />,
      title: 'Individuelle Betreuung',
      description: 'Jeder Mensch ist einzigartig – deshalb erhalten Sie einen vollständig individualisierten Therapieplan.'
    },
    {
      icon: <BookOpen size={24} />,
      title: 'Evidenzbasierte Therapie',
      description: 'Alle Behandlungsmethoden basieren auf aktuellen wissenschaftlichen Erkenntnissen und bewährten Konzepten.'
    },
    {
      icon: <Award size={24} />,
      title: 'Interdisziplinäre Zusammenarbeit',
      description: 'Enge Kooperation mit Ärzt:innen, Trainer:innen und anderen Fachleuten für optimale Betreuung.'
    }
  ];

  return (
    <section
      id="about"
      className={`about-section reveal-section ${isInView ? 'is-visible' : ''}`}
      ref={ref}
    >
      <div className="container">
        <div className="about-content">
          <div className="about-media">
            <div className="about-image reveal-item" style={{ '--reveal-delay': '0ms' }}>
              <div className="image-wrapper">
                <img
                  src={obImage}
                  alt="Oliver Bauer, Sportphysiotherapeut in Hornstein"
                />
              </div>
            </div>
            <figure className="about-graduation reveal-item" style={{ '--reveal-delay': '120ms' }}>
              <div className="image-wrapper graduation-wrapper">
                <img
                  src={masterImage}
                  alt="Master-Abschluss Exercise and Sports Physiotherapy, Escuela Universitaria Real Madrid – Universidad Europea, Madrid"
                  className="graduation-img"
                />
              </div>
              <figcaption className="graduation-caption">
                Abschluss Sportphysiotherapie Master
              </figcaption>
            </figure>
          </div>
          <div className="about-text">
            <h2 className="heading-2 reveal-item" style={{ '--reveal-delay': '40ms' }}>Über mich</h2>
            <div className="about-credentials reveal-item" style={{ '--reveal-delay': '100ms' }}>
              <div className="credential-entry">
                <p className="credential-title">
                  Bachelor of Science in Health Studies (BSc) – Physiotherapie
                </p>
                <p className="credential-meta">
                  Hochschule Burgenland · Campus Pinkafeld
                </p>
              </div>
              <div className="credential-entry">
                <p className="credential-title">Master in Exercise and Sports Physiotherapy</p>
                <p className="credential-meta">
                  Escuela Universitaria Real Madrid – Universidad Europea · Madrid
                </p>
              </div>
            </div>
            <div className="about-description">
              <p className="body-medium reveal-item" style={{ '--reveal-delay': '160ms' }}>
                Sport – insbesondere Fußball – begleitet mich seit meiner Kindheit. Seit über 15 Jahren
                bin ich aktiv, teils auf Leistungsniveau. Eigene Verletzungen führten mich zur Physiotherapie
                und bestärkten meinen Wunsch, im Sportbereich beruflich tätig zu sein. Heute ist es meine
                Leidenschaft, Sportlerinnen und Sportler dabei zu unterstützen, nach Verletzungen ihr volles
                Potenzial zurückzugewinnen.
              </p>
              <p className="body-medium reveal-item" style={{ '--reveal-delay': '220ms' }}>
                Im Bachelorstudium Physiotherapie an der Hochschule Burgenland (Campus Pinkafeld) vertiefte
                ich mein Interesse an wissenschaftlicher Arbeit im Sportbereich, besonders an der
                Verletzungsprävention. In meiner aktuellen Tätigkeit als Physiotherapeut beim FK Austria Wien
                arbeite ich präventiv wie rehabilitativ mit jungen Profisportlern und verbinde beide Bereiche
                optimal.
              </p>
              <p className="body-medium reveal-item" style={{ '--reveal-delay': '280ms' }}>
                Der Mensch steht für mich im Mittelpunkt. Individuell angepasste Therapie und
                kontinuierliche Weiterbildung sind für mich zentral, um evidenzbasiert und auf dem neuesten
                Stand der Wissenschaft zu arbeiten. 2026 habe ich daher das Masterstudium
                „Exercise and Sports Physiotherapy“ an der Escuela Universitaria Real Madrid – Universidad Europea
                in Madrid abgeschlossen, um meine Expertise weiter auszubauen. Im Rahmen des Studiums und durch
                die enge Verbindung zu Real Madrid konnte ich wertvolle Einblicke in den internationalen
                Spitzensport gewinnen und mein Wissen über moderne physiotherapeutische, rehabilitative und
                leistungsorientierte Arbeitsweisen auf höchstem Niveau vertiefen. Diese Erfahrungen fließen
                heute direkt in meine tägliche Arbeit mit Sportlerinnen und Sportlern ein.
              </p>
            </div>
            <div className="values-grid">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="value-item reveal-item"
                  style={{ '--reveal-delay': `${340 + index * 80}ms` }}
                >
                  <div className="value-icon">{value.icon}</div>
                  <div>
                    <h4 className="heading-3" style={{ fontSize: '1.125rem', marginBottom: '0.5rem' }}>
                      {value.title}
                    </h4>
                    <p className="body-small">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
